import { render, staticRenderFns } from "./AdminSystemCtrl.vue?vue&type=template&id=5c14f8df&scoped=true&"
import script from "./AdminSystemCtrl.vue?vue&type=script&lang=js&"
export * from "./AdminSystemCtrl.vue?vue&type=script&lang=js&"
import style0 from "./AdminSystemCtrl.vue?vue&type=style&index=0&id=5c14f8df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c14f8df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c14f8df')) {
      api.createRecord('5c14f8df', component.options)
    } else {
      api.reload('5c14f8df', component.options)
    }
    module.hot.accept("./AdminSystemCtrl.vue?vue&type=template&id=5c14f8df&scoped=true&", function () {
      api.rerender('5c14f8df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminSystemCtrl.vue"
export default component.exports